import Tabs from '@mui/material/Tabs';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import { THEME_COLOR } from '../config';
const MainTabs = (props) => {
    return (
        <Paper square>
            <Tabs
                variant="scrollable"
                value={props.value}
                onChange={props.onChange}
                indicatorColor="primary"
                textColor="primary"
                TabIndicatorProps={{ style: { background: {THEME_COLOR}, } }}
            >
                <Tab label={props.label} />
                <Tab label={props.label1} />
                <Tab label={props.label2} />
                <Tab label={props.label3} />
                <Tab label={props.label4} />
                <Tab label={props.label5} />
            </Tabs>
        </Paper>
    )
}
export { MainTabs }